// 导入封装好的axios实例
import request from '@/utils/request';

const BASE_URL = '/h5/hro/project';

const api = {
    projectList : '/availableProjectList',
    employeeStmBatch: '/findStmBatchEmployeePageByProjectId', // 发薪批次 给项目编号
    employeeStmBatchItem: '/getStmBatchEmployeeItemByStemBatchItemId', // 发薪批次明细 给批次编号
};
/**
 * 
 * @returns 这个获取项目需要提前登录后使用 token进行传送，不然无效
 */
  // 获取项目列表
  export const getProjectList = () => {
	return request({
	url: `${BASE_URL}${api.projectList}`,
	method: 'get',
	});
  };

   // 根据当前项目查询雇员的薪资发放记录分页对象
   export const getStmBatchEmployeeList = (StmBatchEmployeePageData) => {
    const projectId = StmBatchEmployeePageData.projectId ? `/${StmBatchEmployeePageData.projectId}` : '' ;
    const pageNum = StmBatchEmployeePageData.pageNum ? `?pageNum=${StmBatchEmployeePageData.pageNum}` : '' ;
    const pageSize = StmBatchEmployeePageData.pageSize ? `&pageSize=${StmBatchEmployeePageData.pageSize}` : '' ;
    return request({
    url: `${BASE_URL}${api.employeeStmBatch}${projectId}${pageNum}${pageSize}`,
    method: 'get',
    });
    };

       // 根据指定的雇员薪资批次明细Id查询详细
   export const getStmBatchEmployeeItemList = (stmBatchEmployeeItemId) => {
    return request({
    url: `${BASE_URL}${api.employeeStmBatchItem}/${stmBatchEmployeeItemId}`,
    method: 'get',
    });
    };